import { PERMISSIONS_DATA } from './../../common/constants.js';
import { AdminRole } from './../../helpers.js';

export default async function isAdmin({ next, router }) {

    const isAdmin = await AdminRole();
    const condition = isAdmin != null && isAdmin == PERMISSIONS_DATA.ADMIN;
    const loginQuery = { path: "/admin/login" };

    if (!condition) {
        return next(loginQuery);
    }
    return next();
}
